// urls.js — pure in-app ROUTE builders (string in, string out).
//
// Distinct from net-base.js, which resolves NETWORK URLs (which origin does an
// /api, /uploads or /assets call go to). This module answers a different
// question: given a record, what is the SPA path that opens it? No I/O, no DOM,
// no navigation — the caller decides whether to <a href> it or navTo() it.
//
// It exists because consultUrl lived in bridge-core.js, the legacy DOM
// click-router shell (window.OPDBridge, document listeners, innerHTML). The pure
// view-shapers in lib/shape/* need the URL, and importing it from bridge-core
// dragged the whole DOM shell — and, transitively, the Medplum client — into a
// layer that must stay portable. bridge-core re-exports consultUrl, so every
// existing importer keeps working.

import { isMedplumUuid } from './fhir-id.js';

/**
 * /consult/:id with optional ?patient=<Medplum Patient UUID> for on-open
 * auto-grant. The patient id is appended ONLY when it is a real Medplum UUID —
 * an OPD slug in that slot would make the grant look up a resource that does not
 * exist, so a non-UUID is dropped rather than passed through.
 */
export function consultUrl(id, patientId) {
  const base = `/consult/${encodeURIComponent(id)}`;
  if (patientId && isMedplumUuid(patientId)) {
    return `${base}?patient=${encodeURIComponent(patientId)}`;
  }
  return base;
}
